export enum ClaimCategoryType {
    Warranty,
    Returns,
    WarrantyReceiver
}
